// extracted by mini-css-extract-plugin
export default {"form":"styles-module_form---NAI9O","agreement-container":"styles-module_agreement-container---J1KkW","button-container":"styles-module_button-container---mXjCz"};